// Room Assets:
import roomSound from './sounds/roomSound.mp3'
import bg from './bg.jpg'
import bgSmall from './bg_small.jpg'
import wall from './wall.jpg'

// Photos Assets:
import p1 from './photos/1.jpg'
import p2 from './photos/2.jpg'
import p3 from './photos/3.jpg'
import p4 from './photos/4.jpg'
import p5 from './photos/5.jpg'
import p6 from './photos/6.jpg'
import p7 from './photos/7.jpg'
import p8 from './photos/8.jpg'
import p9 from './photos/9.jpg'
import p10 from './photos/10.jpg'
import p11 from './photos/11.jpg'
import p12 from './photos/12.jpg'
import p13 from './photos/13.jpg'
import p14 from './photos/14.jpg'
import p15 from './photos/15.jpg'
import p16 from './photos/16.jpg'
import p17 from './photos/17.jpg'
import p18 from './photos/18.jpg'
import p19 from './photos/19.jpg'
import p20 from './photos/20.jpg'
import p21 from './photos/21.jpg'
import p22 from './photos/22.jpg'
import p23 from './photos/23.jpg'
import p24 from './photos/24.jpg'
import p25 from './photos/25.jpg'
import p26 from './photos/26.jpg'
// import p27 from './photos/27.jpg'
import p28 from './photos/28.jpg'
import p29 from './photos/29.jpg'
import p30 from './photos/30.jpg'
import p31 from './photos/31.jpg'

// Audio:
import s1 from './sounds/SH 1.mp3'
import s2 from './sounds/SH 2.mp3'
import s3 from './sounds/SH 3.mp3'
import s4 from './sounds/SH 4.mp3'
import s5 from './sounds/SH 5.mp3'
import s6 from './sounds/SH 6.mp3'
import s7 from './sounds/SH 7.mp3'
import s8 from './sounds/SH 8.mp3'
// import s9 from './sounds/SH 9.mp3'
// import s10 from './sounds/SH 10.mp3'
// import s11 from './sounds/SH 11.mp3'
// import s12 from './sounds/SH 12.mp3'
import s13 from './sounds/SH 13.mp3'
import s14_15 from './sounds/SH 14-15.mp3'
// import s15 from './sounds/SH 15.mp3'
import s16 from './sounds/SH 16.mp3'
import s17 from './sounds/SH 17.mp3'
import s18 from './sounds/SH 18.mp3'
import s19 from './sounds/SH 19.mp3'
import s20 from './sounds/SH 20.mp3'
import s21 from './sounds/SH 21.mp3'
import s22 from './sounds/SH 22.mp3'
import s23 from './sounds/SH 23.mp3'
import s24 from './sounds/SH 24.mp3'
import s25 from './sounds/SH 25.mp3'
import s26 from './sounds/SH 26_ADDON.mp3'
import s27 from './sounds/SH 26+text.mp3'
import s28 from './sounds/SH 28.mp3'
import s29 from './sounds/SH 29.mp3'
import s30 from './sounds/SH 30.mp3'
import s31 from './sounds/SH 31.mp3'
import wave from './sounds/SH_image.mp3'
import s9_12 from './sounds/SH 9-12.mp3'

const roomContent = [
  {
    wave,
    bgSound: null,
    longSound: [
      { start: 9, end: 12 },
      { start: 14, end: 15 },
    ],
    // textDuration: 240000,
  },
  { img: p1, audio: s1 },
  { img: p2, audio: s2 },
  { img: p3, audio: s3 },
  { img: p4, audio: s4 },
  { img: p5, audio: s5 },
  { img: p6, audio: s6 },
  { img: p7, audio: s7 },
  { img: p8, audio: s8 },
  { img: p9, audio: s9_12, short: true },
  { img: p10, audio: null, short: true },
  { img: p11, audio: null, short: true },
  { img: p12, audio: null, short: true },
  { img: p13, audio: s13 },
  { img: p14, audio: s14_15, short: true },
  { img: p15, audio: null, short: true },
  { img: p16, audio: s16 },
  { img: p17, audio: s17 },
  { img: p18, audio: s18 },
  { img: p19, audio: s19 },
  { img: p20, audio: s20 },
  { img: p21, audio: s21 },
  { img: p22, audio: s22 },
  { img: p23, audio: s23 },
  { img: p24, audio: s24 },
  { img: p25, audio: s25 },
  { img: p26, audio: s26 },
  // { img: null, audio: s27, text: true },
  { img: p28, audio: s28 },
  { img: p29, audio: s29 },
  { img: p30, audio: s30 },
  { img: p31, audio: s31 },
]

export const ROOM_1 = {
  roomSound,
  roomImg: bg,
  roomThumbnail: bgSmall,
  wallImg: wall,
  roomContent,
}
